<template>
  <Modal
    :closeButton="true"
    :size="'modal-md'"
    :restrictBodyHeight="false"
    :showModal="showModal"
    @close="closeModal()"
  >
    <template #header>
      <div class="mb-4 fw-bold">
        {{ modalHeader }}
      </div>
    </template>
    <template #body>
      <div class="d-flex flex-column mb-5">
        <p>{{ modalText }}</p>
      </div>
    </template>
    <template #footer>
      <div class="d-flex flex-row justify-content-end me-4 mb-4">
        <button
          type="button"
          @click="returnToPortal"
          class="btn btn-link fw-bold me-4"
        >
          Leave
        </button>
        <QuestionNav
          :submitButton="{
            btnText: 'Stay'
          }"
          @submit="closeModal"
        />
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '~/components/modal.vue'
import QuestionNav from '~/components/marketplace/subComponents/QuestionNav'

export default {
  name: 'PortalReturnModal',
  props: {
    showModal: Boolean
  },
  emits: ['close'],
  components: {
    Modal,
    QuestionNav
  },
  data() {
    return {
      modalHeader: 'Are you sure you want to go?',
      modalText:
        'Leaving now without saving will erase progress on this page. Do you still wish to leave?'
    }
  },
  methods: {
    async closeModal(revert = true) {
      this.$emit('close', true)
      return
    },
    async returnToPortal() {
      this.$router.push('/portal')
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-title {
  margin-bottom: 0px !important;
}
.modal-body {
  overflow: hidden !important;
}
</style>
